<span id="environmentName" style="margin-left: 5px; margin-right: 3px;">{{ environmentName }}</span>
<span id="frontendVersion" style="margin-left: 2px; margin-right: 3px;">{{ frontendVersion }}</span>
<span id="apiVersion" style="margin-left: 2px;">{{ versionService.apiVersion() }}</span>